export const debugInfo = {
  "log": {
    "version": "1.2",
    "creator": {
      "name": "WebInspector",
      "version": "537.36"
    },
    "pages": [
      {
        "startedDateTime": "2020-04-15T21:09:55.357Z",
        "id": "page_17",
        "title": "http://localhost:3000/",
        "pageTimings": {
          "onContentLoad": 1347.4109999951907,
          "onLoad": 1485.2430000028107
        }
      }
    ],
    "entries": [
      {
        "startedDateTime": "2020-04-15T21:10:06.393Z",
        "time": 27.167000007466413,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:05 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985005,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 182
        },
        "cache": {},
        "timings": {
          "blocked": 2.9280000028694046,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.24100000000000002,
          "wait": 23.665999994066542,
          "receive": 0.33200001053046435,
          "_blocked_queueing": 2.781000002869405
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333237,
                "columnNumber": 67
              },
              {
                "functionName": "constructClassInstance",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 305847,
                "columnNumber": 17
              },
              {
                "functionName": "updateClassComponent",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 307618,
                "columnNumber": 4
              },
              {
                "functionName": "beginWork",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 308445,
                "columnNumber": 15
              },
              {
                "functionName": "performUnitOfWork",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 311183,
                "columnNumber": 11
              },
              {
                "functionName": "workLoop",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 311223,
                "columnNumber": 23
              },
              {
                "functionName": "renderRoot",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 311309,
                "columnNumber": 6
              },
              {
                "functionName": "performWorkOnRoot",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 312200,
                "columnNumber": 6
              },
              {
                "functionName": "performWork",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 312112,
                "columnNumber": 6
              },
              {
                "functionName": "performSyncWork",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 312086,
                "columnNumber": 2
              },
              {
                "functionName": "interactiveUpdates$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 312355,
                "columnNumber": 6
              },
              {
                "functionName": "interactiveUpdates",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 295532,
                "columnNumber": 9
              },
              {
                "functionName": "dispatchInteractiveEvent",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 298239,
                "columnNumber": 2
              }
            ]
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.421Z",
        "time": 308.51199999918504,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/hud/hud_theme_profile.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"172e-1717731e1f4\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 696,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"172e-1717731e1f4\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "5934"
            }
          ],
          "cookies": [],
          "content": {
            "size": 5934,
            "mimeType": "image/png",
            "compression": 5947,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 256,
          "bodySize": -13,
          "_transferSize": 243
        },
        "cache": {},
        "timings": {
          "blocked": 3.958999991818331,
          "dns": 0.01200000000000001,
          "ssl": -1,
          "connect": 300.998,
          "send": 0.24399999999997135,
          "wait": 2.6359999939203362,
          "receive": 0.6630000134464353,
          "_blocked_queueing": 2.339999991818331
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [],
            "parent": {
              "description": "Image",
              "callFrames": [
                {
                  "functionName": "setValueForProperty",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 296370,
                  "columnNumber": 13
                },
                {
                  "functionName": "setInitialDOMProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300818,
                  "columnNumber": 6
                },
                {
                  "functionName": "setInitialProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300985,
                  "columnNumber": 2
                },
                {
                  "functionName": "finalizeInitialChildren",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 301966,
                  "columnNumber": 2
                },
                {
                  "functionName": "completeWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308916,
                  "columnNumber": 16
                },
                {
                  "functionName": "completeUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311013,
                  "columnNumber": 25
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311211,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544637",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.422Z",
        "time": 309.629999993735,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/hud/hud_icon_star.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"27bc-1717731e1e7\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 685,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"27bc-1717731e1e7\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "10172"
            }
          ],
          "cookies": [],
          "content": {
            "size": 10172,
            "mimeType": "image/png",
            "compression": 10186,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 257,
          "bodySize": -14,
          "_transferSize": 243
        },
        "cache": {},
        "timings": {
          "blocked": 5.091000005639158,
          "dns": 0.006999999999999895,
          "ssl": -1,
          "connect": 301.301,
          "send": 0.10700000000002774,
          "wait": 1.8289999935254286,
          "receive": 1.2949999945703894,
          "_blocked_queueing": 3.305000005639158
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [],
            "parent": {
              "description": "Image",
              "callFrames": [
                {
                  "functionName": "setValueForProperty",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 296370,
                  "columnNumber": 13
                },
                {
                  "functionName": "setInitialDOMProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300818,
                  "columnNumber": 6
                },
                {
                  "functionName": "setInitialProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300985,
                  "columnNumber": 2
                },
                {
                  "functionName": "finalizeInitialChildren",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 301966,
                  "columnNumber": 2
                },
                {
                  "functionName": "completeWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308916,
                  "columnNumber": 16
                },
                {
                  "functionName": "completeUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311013,
                  "columnNumber": 25
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311211,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544638",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.422Z",
        "time": 310.24299999990035,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/hud/hud_siu_logo_tiny.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"4194-1717731e1ea\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 689,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"4194-1717731e1ea\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "16788"
            }
          ],
          "cookies": [],
          "content": {
            "size": 16788,
            "mimeType": "image/png",
            "compression": 16802,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 257,
          "bodySize": -14,
          "_transferSize": 243
        },
        "cache": {},
        "timings": {
          "blocked": 306.65599999157433,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.06200000000001182,
          "wait": 2.3959999971929733,
          "receive": 1.12900001113303,
          "_blocked_queueing": 4.552999991574325
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [],
            "parent": {
              "description": "Image",
              "callFrames": [
                {
                  "functionName": "setValueForProperty",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 296370,
                  "columnNumber": 13
                },
                {
                  "functionName": "setInitialDOMProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300818,
                  "columnNumber": 6
                },
                {
                  "functionName": "setInitialProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300985,
                  "columnNumber": 2
                },
                {
                  "functionName": "finalizeInitialChildren",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 301966,
                  "columnNumber": 2
                },
                {
                  "functionName": "completeWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308916,
                  "columnNumber": 16
                },
                {
                  "functionName": "completeUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311013,
                  "columnNumber": 25
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311211,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544636",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.422Z",
        "time": 311.0949999972945,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/hud/hud_icon_heart.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"1bdd-1717731e1e7\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 686,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"1bdd-1717731e1e7\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "7133"
            }
          ],
          "cookies": [],
          "content": {
            "size": 7133,
            "mimeType": "image/png",
            "compression": 7146,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 256,
          "bodySize": -13,
          "_transferSize": 243
        },
        "cache": {},
        "timings": {
          "blocked": 307.3099999977909,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.07499999999998863,
          "wait": 2.9389999931510715,
          "receive": 0.7710000063525513,
          "_blocked_queueing": 5.602999997790903
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [],
            "parent": {
              "description": "Image",
              "callFrames": [
                {
                  "functionName": "setValueForProperty",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 296370,
                  "columnNumber": 13
                },
                {
                  "functionName": "setInitialDOMProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300818,
                  "columnNumber": 6
                },
                {
                  "functionName": "setInitialProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300985,
                  "columnNumber": 2
                },
                {
                  "functionName": "finalizeInitialChildren",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 301966,
                  "columnNumber": 2
                },
                {
                  "functionName": "completeWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308916,
                  "columnNumber": 16
                },
                {
                  "functionName": "completeUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311013,
                  "columnNumber": 25
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311211,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544637",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.422Z",
        "time": 312.26999999489635,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/hud/hud_btn_plus.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"cd1-1717731e1e5\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 683,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"cd1-1717731e1e5\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "3281"
            }
          ],
          "cookies": [],
          "content": {
            "size": 3281,
            "mimeType": "image/png",
            "compression": 3294,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 255,
          "bodySize": -13,
          "_transferSize": 242
        },
        "cache": {},
        "timings": {
          "blocked": 6.849999990663491,
          "dns": 0,
          "ssl": -1,
          "connect": 300.107,
          "send": 1.3769999999999527,
          "wait": 2.8330000019017803,
          "receive": 1.1030000023311004,
          "_blocked_queueing": 6.849999990663491
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [],
            "parent": {
              "description": "Image",
              "callFrames": [
                {
                  "functionName": "setValueForProperty",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 296370,
                  "columnNumber": 13
                },
                {
                  "functionName": "setInitialDOMProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300818,
                  "columnNumber": 6
                },
                {
                  "functionName": "setInitialProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300985,
                  "columnNumber": 2
                },
                {
                  "functionName": "finalizeInitialChildren",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 301966,
                  "columnNumber": 2
                },
                {
                  "functionName": "completeWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308916,
                  "columnNumber": 16
                },
                {
                  "functionName": "completeUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311013,
                  "columnNumber": 25
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311211,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544639",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.423Z",
        "time": 312.2189999994589,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/lobby/nav_themes_coming_soon.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"3f4d-1717731e21e\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 696,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"3f4d-1717731e21e\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "16205"
            }
          ],
          "cookies": [],
          "content": {
            "size": 16205,
            "mimeType": "image/png",
            "compression": 16219,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 257,
          "bodySize": -14,
          "_transferSize": 243
        },
        "cache": {},
        "timings": {
          "blocked": 308.12500000395346,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.06400000000002137,
          "wait": 3.0010000036740507,
          "receive": 1.0289999918313697,
          "_blocked_queueing": 7.620000003953464
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [],
            "parent": {
              "description": "Image",
              "callFrames": [
                {
                  "functionName": "setValueForProperty",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 296370,
                  "columnNumber": 13
                },
                {
                  "functionName": "setInitialDOMProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300818,
                  "columnNumber": 6
                },
                {
                  "functionName": "setInitialProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300985,
                  "columnNumber": 2
                },
                {
                  "functionName": "finalizeInitialChildren",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 301966,
                  "columnNumber": 2
                },
                {
                  "functionName": "completeWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308916,
                  "columnNumber": 16
                },
                {
                  "functionName": "completeUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311013,
                  "columnNumber": 25
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311211,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544638",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.423Z",
        "time": 306.1420000012731,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/lobby/nav_quests_coming_soon.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"3ee0-1717731e21d\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 696,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"3ee0-1717731e21d\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "16096"
            }
          ],
          "cookies": [],
          "content": {
            "size": 16096,
            "mimeType": "image/png",
            "compression": 16110,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 257,
          "bodySize": -14,
          "_transferSize": 243
        },
        "cache": {},
        "timings": {
          "blocked": 9.198999992804602,
          "dns": 0,
          "ssl": -1,
          "connect": 294.119,
          "send": 0.21699999999998454,
          "wait": 1.8909999989075459,
          "receive": 0.7160000095609576,
          "_blocked_queueing": 9.198999992804602
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [],
            "parent": {
              "description": "Image",
              "callFrames": [
                {
                  "functionName": "setValueForProperty",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 296370,
                  "columnNumber": 13
                },
                {
                  "functionName": "setInitialDOMProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300818,
                  "columnNumber": 6
                },
                {
                  "functionName": "setInitialProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300985,
                  "columnNumber": 2
                },
                {
                  "functionName": "finalizeInitialChildren",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 301966,
                  "columnNumber": 2
                },
                {
                  "functionName": "completeWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308916,
                  "columnNumber": 16
                },
                {
                  "functionName": "completeUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311013,
                  "columnNumber": 25
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311211,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544636",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.423Z",
        "time": 313.51000000722706,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/lobby/nav_home.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"2890-1717731e21c\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 682,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"2890-1717731e21c\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "10384"
            }
          ],
          "cookies": [],
          "content": {
            "size": 10384,
            "mimeType": "image/png",
            "compression": 10398,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 257,
          "bodySize": -14,
          "_transferSize": 243
        },
        "cache": {},
        "timings": {
          "blocked": 310.3790000053225,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.10699999999999976,
          "wait": 2.4329999982807786,
          "receive": 0.5910000036237761,
          "_blocked_queueing": 307.4650000053225
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [],
            "parent": {
              "description": "Image",
              "callFrames": [
                {
                  "functionName": "setValueForProperty",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 296370,
                  "columnNumber": 13
                },
                {
                  "functionName": "setInitialDOMProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300818,
                  "columnNumber": 6
                },
                {
                  "functionName": "setInitialProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300985,
                  "columnNumber": 2
                },
                {
                  "functionName": "finalizeInitialChildren",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 301966,
                  "columnNumber": 2
                },
                {
                  "functionName": "completeWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308916,
                  "columnNumber": 16
                },
                {
                  "functionName": "completeUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311013,
                  "columnNumber": 25
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311211,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544637",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.423Z",
        "time": 314.97000000672415,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/lobby/nav_leaderboard_coming_soon.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"3d43-1717731e21d\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 701,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"3d43-1717731e21d\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "15683"
            }
          ],
          "cookies": [],
          "content": {
            "size": 15683,
            "mimeType": "image/png",
            "compression": 15697,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 257,
          "bodySize": -14,
          "_transferSize": 243
        },
        "cache": {},
        "timings": {
          "blocked": 311.71700000867435,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.07499999999999973,
          "wait": 2.5420000010197983,
          "receive": 0.6359999970300123,
          "_blocked_queueing": 308.61400000867434
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [],
            "parent": {
              "description": "Image",
              "callFrames": [
                {
                  "functionName": "setValueForProperty",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 296370,
                  "columnNumber": 13
                },
                {
                  "functionName": "setInitialDOMProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300818,
                  "columnNumber": 6
                },
                {
                  "functionName": "setInitialProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300985,
                  "columnNumber": 2
                },
                {
                  "functionName": "finalizeInitialChildren",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 301966,
                  "columnNumber": 2
                },
                {
                  "functionName": "completeWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308916,
                  "columnNumber": 16
                },
                {
                  "functionName": "completeUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311013,
                  "columnNumber": 25
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311211,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544638",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.423Z",
        "time": 315.6759999983479,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/lobby/nav_hearts_coming_soon.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"3ca6-1717731e21b\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 696,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"3ca6-1717731e21b\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "15526"
            }
          ],
          "cookies": [],
          "content": {
            "size": 15526,
            "mimeType": "image/png",
            "compression": 15540,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 257,
          "bodySize": -14,
          "_transferSize": 243
        },
        "cache": {},
        "timings": {
          "blocked": 312.37600000098536,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.06899999999999995,
          "wait": 2.490000001166016,
          "receive": 0.7409999961964786,
          "_blocked_queueing": 309.40800000098534
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [],
            "parent": {
              "description": "Image",
              "callFrames": [
                {
                  "functionName": "setValueForProperty",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 296370,
                  "columnNumber": 13
                },
                {
                  "functionName": "setInitialDOMProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300818,
                  "columnNumber": 6
                },
                {
                  "functionName": "setInitialProperties",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 300985,
                  "columnNumber": 2
                },
                {
                  "functionName": "finalizeInitialChildren",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 301966,
                  "columnNumber": 2
                },
                {
                  "functionName": "completeWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308916,
                  "columnNumber": 16
                },
                {
                  "functionName": "completeUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311013,
                  "columnNumber": 25
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311211,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544639",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.424Z",
        "time": 315.8209999965038,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/lobby/bg.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"7a6-1700785a8d4\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Sun, 02 Feb 2020 20:09:24 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 675,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Sun, 02 Feb 2020 20:09:24 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"7a6-1700785a8d4\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "1958"
            }
          ],
          "cookies": [],
          "content": {
            "size": 1958,
            "mimeType": "image/png",
            "compression": 1971,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 255,
          "bodySize": -13,
          "_transferSize": 242
        },
        "cache": {},
        "timings": {
          "blocked": 312.48899999393245,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.07500000000000018,
          "wait": 2.7740000064056365,
          "receive": 0.48299999616574496,
          "_blocked_queueing": 309.85999999393243
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "other"
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544637",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.424Z",
        "time": 316.40199999674223,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/hud/hud_theme_vegas.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"793-1717731e1f5\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 693,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"793-1717731e1f5\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "1939"
            }
          ],
          "cookies": [],
          "content": {
            "size": 1939,
            "mimeType": "image/png",
            "compression": 1952,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 255,
          "bodySize": -13,
          "_transferSize": 242
        },
        "cache": {},
        "timings": {
          "blocked": 313.0059999953993,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.07999999999999963,
          "wait": 2.835000005854294,
          "receive": 0.48099999548867345,
          "_blocked_queueing": 310.80999999539927
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "other"
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544636",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.425Z",
        "time": 316.9400000042515,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/lobby/lobby_btn_newGame_withText.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"3ea0-1717731e218\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 700,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"3ea0-1717731e218\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "16032"
            }
          ],
          "cookies": [],
          "content": {
            "size": 16032,
            "mimeType": "image/png",
            "compression": 16046,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 257,
          "bodySize": -14,
          "_transferSize": 243
        },
        "cache": {},
        "timings": {
          "blocked": 312.99599999521206,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.06799999999999962,
          "wait": 3.2909999928949403,
          "receive": 0.5850000161444768,
          "_blocked_queueing": 310.65899999521207
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "other"
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544638",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.425Z",
        "time": 316.9469999993452,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/lobby/lobby_nav_mask.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"92f-1717731e219\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 687,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"92f-1717731e219\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "2351"
            }
          ],
          "cookies": [],
          "content": {
            "size": 2351,
            "mimeType": "image/png",
            "compression": 2364,
            "text": "iVBORw0KGgoAAAANSUhEUgAAAWgAAACLCAYAAABMQgNNAAAACXBIWXMAAAsTAAALEwEAmpwYAAAF6mlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4gPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxNDggNzkuMTY0MDM2LCAyMDE5LzA4LzEzLTAxOjA2OjU3ICAgICAgICAiPiA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPiA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIiB4bWxuczp4bXA9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC8iIHhtbG5zOnhtcE1NPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvbW0vIiB4bWxuczpzdFJlZj0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL3NUeXBlL1Jlc291cmNlUmVmIyIgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIgeG1sbnM6ZGM9Imh0dHA6Ly9wdXJsLm9yZy9kYy9lbGVtZW50cy8xLjEvIiB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKE1hY2ludG9zaCkiIHhtcDpDcmVhdGVEYXRlPSIyMDIwLTAyLTAzVDIxOjU5OjMxLTA4OjAwIiB4bXA6TW9kaWZ5RGF0ZT0iMjAyMC0wMi0wM1QyMjowMToyMC0wODowMCIgeG1wOk1ldGFkYXRhRGF0ZT0iMjAyMC0wMi0wM1QyMjowMToyMC0wODowMCIgeG1wTU06SW5zdGFuY2VJRD0ieG1wLmlpZDoyMzYzNDhjMC0wZDlhLTY0NDAtYmU0NS1kNTYwZDdmNmUyMjgiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6RTFEOTcxNjQwRDZGMTFFQTgyMjJFRTkwNTZCNUNDRDkiIHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD0ieG1wLmRpZDpFMUQ5NzE2NDBENkYxMUVBODIyMkVFOTA1NkI1Q0NEOSIgZGM6Zm9ybWF0PSJpbWFnZS9wbmciIHBob3Rvc2hvcDpDb2xvck1vZGU9IjMiIHBob3Rvc2hvcDpJQ0NQcm9maWxlPSJzUkdCIElFQzYxOTY2LTIuMSI+IDx4bXBNTTpEZXJpdmVkRnJvbSBzdFJlZjppbnN0YW5jZUlEPSJ4bXAuaWlkOkUxRDk3MTYxMEQ2RjExRUE4MjIyRUU5MDU2QjVDQ0Q5IiBzdFJlZjpkb2N1bWVudElEPSJ4bXAuZGlkOkUxRDk3MTYyMEQ2RjExRUE4MjIyRUU5MDU2QjVDQ0Q5Ii8+IDx4bXBNTTpIaXN0b3J5PiA8cmRmOlNlcT4gPHJkZjpsaSBzdEV2dDphY3Rpb249InNhdmVkIiBzdEV2dDppbnN0YW5jZUlEPSJ4bXAuaWlkOjIzNjM0OGMwLTBkOWEtNjQ0MC1iZTQ1LWQ1NjBkN2Y2ZTIyOCIgc3RFdnQ6d2hlbj0iMjAyMC0wMi0wM1QyMjowMToyMC0wODowMCIgc3RFdnQ6c29mdHdhcmVBZ2VudD0iQWRvYmUgUGhvdG9zaG9wIDIxLjAgKFdpbmRvd3MpIiBzdEV2dDpjaGFuZ2VkPSIvIi8+IDwvcmRmOlNlcT4gPC94bXBNTTpIaXN0b3J5PiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PnG0bZoAAALrSURBVHja7d0xbttAFEXRR0apsxGvN1tKl41kCRTnpxCQtGJh4ME8BzDcz0AXH8MRtf359fN3Zn1k276He5o57L/9txB9Htm2JHte/7npJ9T+23/LUGh/xXm3Endm/+0/pRP0/12yGvf+lFoC+0/fBA2AQAMg0AACDYBAAwg0AAINgEADCDQAAg0g0AAINAACDSDQAAg0gEADINAAAg2AQAMg0AACDYBAAwg0AAINwD+PZPL6A6Ar0LOsAkBvoE3QAH2BzinQAI2BniXQAJ0T9Ag0QGmgnwINYIIGQKABBBqAzwl0nEEDlE7Qh0ADVAZ6nckINEBdoGcEGqB0gnbEAdAZ6DlM0ACVgfayJIDSQK8ziXdCA/QFeo54aT9A5QT9NEEDNAZ6PCQEKJ6gHXEAlAbaLQ6AwkC7ZgdQGmi3OACKA71M0AB1gZ7TGTRA6QTtm4QAnYFeZ7IJNEBfoHMkS6AB+gLthf0ApYFeyzU7gM5Ae0gI0BnonCZogNoJWqABGgO94ogDoDDQs8YtDoDKCfr0PmiA3kA74gDoC/Q6XbMDqAz0+KIKQOsE7SEhQGegDxM0QGWg8xRogMpAuwcNUBroteIXrwAqA30INEBnoF2DBugMdLwrCaDSbgkASidoFzgASgOdiYeEAIUccQCYoAG4FOgRaAATNADvcwYNINAAXOEMGsAEDYBAAwg0AJ/lkeUHVQBM0AAINIBAAyDQAHfymEnGT14BFE7QbnAAlAYaAIEG4EKgnXAAdPLCfoDWCdoSAAg0ABd4YT+ACRoAgQb4AtziAKgN9BJogEZ7NosA0DlBO+IAKJ2gARBoAN7niyoArYF2Bg3QyREHgEADcC3QjjcATNAAvM8tDgATNAACDfAFuAcN0BpobQYwQQNwgTNoAIEG4ApHHACtgZ4INEAjRxwAAg3AFc6gAUzQAFwLtOkZwAQNwPu8iwOgNdAeEgJ0csQBUBzob5YBoM8jkx8Zkb45+2//KfQXqUbxmB0H09EAAAAASUVORK5CYII=",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 255,
          "bodySize": -13,
          "_transferSize": 242
        },
        "cache": {},
        "timings": {
          "blocked": 313.9789999950016,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.08000000000000007,
          "wait": 2.2469999983450397,
          "receive": 0.6410000059986487,
          "_blocked_queueing": 311.7329999950016
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "other"
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544639",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:06.426Z",
        "time": 317.2400000039488,
        "request": {
          "method": "GET",
          "url": "http://localhost:3000/assets/lobby/lobby_nav_bg.png",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "Host",
              "value": "localhost:3000"
            },
            {
              "name": "Connection",
              "value": "keep-alive"
            },
            {
              "name": "User-Agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "Accept",
              "value": "image/webp,image/apng,image/*,*/*;q=0.8"
            },
            {
              "name": "Sec-Fetch-Site",
              "value": "same-origin"
            },
            {
              "name": "Sec-Fetch-Mode",
              "value": "no-cors"
            },
            {
              "name": "Sec-Fetch-Dest",
              "value": "image"
            },
            {
              "name": "Referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "Accept-Encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "Accept-Language",
              "value": "en-US,en;q=0.9"
            },
            {
              "name": "Cookie",
              "value": "_ga=GA1.1.654794689.1584572929; _gid=GA1.1.1850660453.1586971064; _gat_gtag_UA_138238870_1=1; _ga_KFVGZ7J3PB=GS1.1.1586984995.9.1.1586985000.0"
            },
            {
              "name": "If-None-Match",
              "value": "W/\"9ad-1717731e218\""
            },
            {
              "name": "If-Modified-Since",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            }
          ],
          "queryString": [],
          "cookies": [
            {
              "name": "_ga",
              "value": "GA1.1.654794689.1584572929",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gid",
              "value": "GA1.1.1850660453.1586971064",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_gat_gtag_UA_138238870_1",
              "value": "1",
              "expires": null,
              "httpOnly": false,
              "secure": false
            },
            {
              "name": "_ga_KFVGZ7J3PB",
              "value": "GS1.1.1586984995.9.1.1586985000.0",
              "expires": null,
              "httpOnly": false,
              "secure": false
            }
          ],
          "headersSize": 685,
          "bodySize": 0
        },
        "response": {
          "status": 200,
          "statusText": "OK",
          "httpVersion": "HTTP/1.1",
          "headers": [
            {
              "name": "X-Powered-By",
              "value": "Express"
            },
            {
              "name": "Accept-Ranges",
              "value": "bytes"
            },
            {
              "name": "Cache-Control",
              "value": "public, max-age=0"
            },
            {
              "name": "Last-Modified",
              "value": "Tue, 14 Apr 2020 05:38:10 GMT"
            },
            {
              "name": "Date",
              "value": "Wed, 15 Apr 2020 21:10:06 GMT"
            },
            {
              "name": "ETag",
              "value": "W/\"9ad-1717731e218\""
            },
            {
              "name": "Content-Type",
              "value": "image/png"
            },
            {
              "name": "Content-Length",
              "value": "2477"
            }
          ],
          "cookies": [],
          "content": {
            "size": 2477,
            "mimeType": "image/png",
            "compression": 2490,
            "text": "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",
            "encoding": "base64"
          },
          "redirectURL": "",
          "headersSize": 255,
          "bodySize": -13,
          "_transferSize": 242
        },
        "cache": {},
        "timings": {
          "blocked": 315.022999998061,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.08900000000000019,
          "wait": 1.8189999958677217,
          "receive": 0.3090000100200996,
          "_blocked_queueing": 313.267999998061
        },
        "serverIPAddress": "127.0.0.1",
        "_initiator": {
          "type": "other"
        },
        "_priority": "High",
        "_resourceType": "image",
        "connection": "544636",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:11.396Z",
        "time": 27.28400001069531,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:10 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985010,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 159
        },
        "cache": {},
        "timings": {
          "blocked": 2.7970000033387916,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.24499999999999994,
          "wait": 24.058000003273598,
          "receive": 0.18400000408291817,
          "_blocked_queueing": 2.4600000033387914
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333233,
                "columnNumber": 68
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:11.397Z",
        "time": 26.280999998562038,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=get-notifications",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=get-notifications"
            },
            {
              "name": "content-length",
              "value": "93"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "get-notifications"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 93,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"get-notifications\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "68"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:10 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 68,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"UserNotifications\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 114
        },
        "cache": {},
        "timings": {
          "blocked": 2.6759999898178504,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.14,
          "wait": 23.023000004630536,
          "receive": 0.4420000041136518,
          "_blocked_queueing": 2.5919999898178503
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331179,
                "columnNumber": 26
              },
              {
                "functionName": "clearNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348513,
                "columnNumber": 55
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333234,
                "columnNumber": 70
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:16.395Z",
        "time": 28.927999999723397,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:15 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985015,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 159
        },
        "cache": {},
        "timings": {
          "blocked": 2.5580000048289078,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.20499999999999996,
          "wait": 25.923999993342907,
          "receive": 0.2410000015515834,
          "_blocked_queueing": 2.1850000048289075
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333233,
                "columnNumber": 68
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:16.396Z",
        "time": 27.10799999476876,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=get-notifications",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=get-notifications"
            },
            {
              "name": "content-length",
              "value": "93"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "get-notifications"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 93,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"get-notifications\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "68"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:15 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 68,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"UserNotifications\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 114
        },
        "cache": {},
        "timings": {
          "blocked": 2.4999999974118547,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.12400000000000001,
          "wait": 24.10300000661798,
          "receive": 0.3809999907389283,
          "_blocked_queueing": 2.4209999974118546
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331179,
                "columnNumber": 26
              },
              {
                "functionName": "clearNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348513,
                "columnNumber": 55
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333234,
                "columnNumber": 70
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:21.395Z",
        "time": 26.820999992196448,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:20 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985020,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 159
        },
        "cache": {},
        "timings": {
          "blocked": 2.637999987776391,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.21999999999999997,
          "wait": 23.774999998982995,
          "receive": 0.1880000054370612,
          "_blocked_queueing": 2.499999987776391
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333233,
                "columnNumber": 68
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:21.396Z",
        "time": 25.766999999177642,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=get-notifications",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=get-notifications"
            },
            {
              "name": "content-length",
              "value": "93"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "get-notifications"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 93,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"get-notifications\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "68"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:20 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 68,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"UserNotifications\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 114
        },
        "cache": {},
        "timings": {
          "blocked": 2.958999999327585,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.11900000000000001,
          "wait": 22.353000002517366,
          "receive": 0.33599999733269215,
          "_blocked_queueing": 2.877999999327585
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331179,
                "columnNumber": 26
              },
              {
                "functionName": "clearNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348513,
                "columnNumber": 55
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333234,
                "columnNumber": 70
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:27.062Z",
        "time": 27.5240000046324,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:25 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985025,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 159
        },
        "cache": {},
        "timings": {
          "blocked": 3.0399999940879643,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.21500000000000002,
          "wait": 23.98500000171177,
          "receive": 0.2840000088326633,
          "_blocked_queueing": 2.9269999940879643
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333233,
                "columnNumber": 68
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:27.063Z",
        "time": 25.11600000434555,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=get-notifications",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=get-notifications"
            },
            {
              "name": "content-length",
              "value": "93"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "get-notifications"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 93,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"get-notifications\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "68"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:25 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 68,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"UserNotifications\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 114
        },
        "cache": {},
        "timings": {
          "blocked": 2.753000003869645,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.127,
          "wait": 21.94499999654945,
          "receive": 0.291000003926456,
          "_blocked_queueing": 2.6550000038696453
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331179,
                "columnNumber": 26
              },
              {
                "functionName": "clearNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348513,
                "columnNumber": 55
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333234,
                "columnNumber": 70
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:32.084Z",
        "time": 35.66000000864733,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:31 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985031,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 159
        },
        "cache": {},
        "timings": {
          "blocked": 2.2359999985583126,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.20600000000000002,
          "wait": 32.974999993308444,
          "receive": 0.24300001678057015,
          "_blocked_queueing": 2.1019999985583127
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333233,
                "columnNumber": 68
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:32.084Z",
        "time": 31.24500000558328,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=get-notifications",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=get-notifications"
            },
            {
              "name": "content-length",
              "value": "93"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "get-notifications"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 93,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"get-notifications\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "68"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:31 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 68,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"UserNotifications\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 117
        },
        "cache": {},
        "timings": {
          "blocked": 2.2400000007664786,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.11199999999999999,
          "wait": 28.602999993952924,
          "receive": 0.29000001086387783,
          "_blocked_queueing": 2.1730000007664785
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331179,
                "columnNumber": 26
              },
              {
                "functionName": "clearNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348513,
                "columnNumber": 55
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333234,
                "columnNumber": 70
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:37.084Z",
        "time": 26.14299999549985,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:36 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985036,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 182
        },
        "cache": {},
        "timings": {
          "blocked": 2.544000001964159,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.199,
          "wait": 23.050000006015413,
          "receive": 0.3499999875202775,
          "_blocked_queueing": 2.2840000019641593
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333233,
                "columnNumber": 68
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:37.085Z",
        "time": 30.8870000008028,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=get-notifications",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=get-notifications"
            },
            {
              "name": "content-length",
              "value": "93"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "get-notifications"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 93,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"get-notifications\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "68"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:36 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 68,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"UserNotifications\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 91
        },
        "cache": {},
        "timings": {
          "blocked": 3.4210000039516015,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.117,
          "wait": 26.98300000391435,
          "receive": 0.3659999929368496,
          "_blocked_queueing": 3.3430000039516017
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331179,
                "columnNumber": 26
              },
              {
                "functionName": "clearNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348513,
                "columnNumber": 55
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333234,
                "columnNumber": 70
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:42.083Z",
        "time": 28.63200000138022,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:41 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985041,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 163
        },
        "cache": {},
        "timings": {
          "blocked": 2.8750000099735336,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.191,
          "wait": 25.231999994751067,
          "receive": 0.33399999665562063,
          "_blocked_queueing": 2.7590000099735335
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333233,
                "columnNumber": 68
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:42.084Z",
        "time": 24.299000011524186,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=get-notifications",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=get-notifications"
            },
            {
              "name": "content-length",
              "value": "93"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "get-notifications"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 93,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"get-notifications\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "68"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:41 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 68,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"UserNotifications\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 114
        },
        "cache": {},
        "timings": {
          "blocked": 2.79000001166109,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.144,
          "wait": 21.04499999339506,
          "receive": 0.3200000064680353,
          "_blocked_queueing": 2.72100001166109
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331179,
                "columnNumber": 26
              },
              {
                "functionName": "clearNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348513,
                "columnNumber": 55
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333234,
                "columnNumber": 70
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:47.084Z",
        "time": 27.304999995976686,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:46 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985046,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 159
        },
        "cache": {},
        "timings": {
          "blocked": 2.4149999936725943,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.27499999999999997,
          "wait": 24.42499999618996,
          "receive": 0.1900000061141327,
          "_blocked_queueing": 2.2809999936725944
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333233,
                "columnNumber": 68
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:47.085Z",
        "time": 26.310000001103617,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=get-notifications",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=get-notifications"
            },
            {
              "name": "content-length",
              "value": "93"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "get-notifications"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 93,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"get-notifications\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "68"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:46 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 68,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"UserNotifications\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 114
        },
        "cache": {},
        "timings": {
          "blocked": 2.8969999986402692,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.178,
          "wait": 22.931000001411885,
          "receive": 0.3040000010514632,
          "_blocked_queueing": 2.789999998640269
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331179,
                "columnNumber": 26
              },
              {
                "functionName": "clearNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348513,
                "columnNumber": 55
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333234,
                "columnNumber": 70
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:52.083Z",
        "time": 25.231999999959953,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:51 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985051,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 159
        },
        "cache": {},
        "timings": {
          "blocked": 2.5300000079013407,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.267,
          "wait": 22.27499999610055,
          "receive": 0.15999999595806003,
          "_blocked_queueing": 2.4090000079013407
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333233,
                "columnNumber": 68
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:52.084Z",
        "time": 24.09399999305606,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=get-notifications",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=get-notifications"
            },
            {
              "name": "content-length",
              "value": "93"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "get-notifications"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 93,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"get-notifications\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "68"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:51 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 68,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"UserNotifications\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 114
        },
        "cache": {},
        "timings": {
          "blocked": 2.4230000050161036,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.149,
          "wait": 21.155999995103105,
          "receive": 0.3659999929368496,
          "_blocked_queueing": 2.3360000050161034
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331179,
                "columnNumber": 26
              },
              {
                "functionName": "clearNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348513,
                "columnNumber": 55
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333234,
                "columnNumber": 70
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:56.395Z",
        "time": 27.673000004142523,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:55 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985055,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 159
        },
        "cache": {},
        "timings": {
          "blocked": 2.717000001494773,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.193,
          "wait": 24.515999999064952,
          "receive": 0.24700000358279794,
          "_blocked_queueing": 2.6050000014947727
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333233,
                "columnNumber": 68
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:10:56.396Z",
        "time": 24.332000000867993,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=get-notifications",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=get-notifications"
            },
            {
              "name": "content-length",
              "value": "93"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "get-notifications"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 93,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"get-notifications\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "68"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:10:55 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 68,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"UserNotifications\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 114
        },
        "cache": {},
        "timings": {
          "blocked": 2.706999994390644,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.11900000000000001,
          "wait": 21.20099999781139,
          "receive": 0.30500000866595656,
          "_blocked_queueing": 2.626999994390644
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331179,
                "columnNumber": 26
              },
              {
                "functionName": "clearNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348513,
                "columnNumber": 55
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333234,
                "columnNumber": 70
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:11:01.394Z",
        "time": 29.0580000000773,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:11:00 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985060,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 159
        },
        "cache": {},
        "timings": {
          "blocked": 2.8000000001508742,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.193,
          "wait": 25.857000002270563,
          "receive": 0.20799999765586108,
          "_blocked_queueing": 2.6870000001508743
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333233,
                "columnNumber": 68
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:11:01.395Z",
        "time": 27.872999999090098,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=get-notifications",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=get-notifications"
            },
            {
              "name": "content-length",
              "value": "93"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "get-notifications"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 93,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"get-notifications\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "68"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:11:00 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 68,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"UserNotifications\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 114
        },
        "cache": {},
        "timings": {
          "blocked": 3.881999997742474,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.16500000000000004,
          "wait": 23.50999999623373,
          "receive": 0.31600000511389226,
          "_blocked_queueing": 3.775999997742474
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331179,
                "columnNumber": 26
              },
              {
                "functionName": "clearNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348513,
                "columnNumber": 55
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333234,
                "columnNumber": 70
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:11:06.394Z",
        "time": 26.767000003019348,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:11:05 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985065,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 159
        },
        "cache": {},
        "timings": {
          "blocked": 2.738999999630265,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.278,
          "wait": 23.561000004889443,
          "receive": 0.18899999849963933,
          "_blocked_queueing": 2.577999999630265
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333233,
                "columnNumber": 68
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:11:06.395Z",
        "time": 25.703999999677762,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=get-notifications",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=get-notifications"
            },
            {
              "name": "content-length",
              "value": "93"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "get-notifications"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 93,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"get-notifications\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "68"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:11:05 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 68,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"UserNotifications\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 114
        },
        "cache": {},
        "timings": {
          "blocked": 3.446000001920387,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.186,
          "wait": 21.71900000194553,
          "receive": 0.3529999958118424,
          "_blocked_queueing": 3.337000001920387
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331179,
                "columnNumber": 26
              },
              {
                "functionName": "clearNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348513,
                "columnNumber": 55
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333234,
                "columnNumber": 70
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:11:11.394Z",
        "time": 28.47200000542216,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=lobby",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=lobby"
            },
            {
              "name": "content-length",
              "value": "81"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "lobby"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 81,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"lobby\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "136"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:11:10 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 136,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"ServerTime\":1586985070,\"MatchSummaries\":[],\"CompletedSummaries\":[],\"OpponentSummaries\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 159
        },
        "cache": {},
        "timings": {
          "blocked": 2.7640000033387913,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.203,
          "wait": 25.16599999645911,
          "receive": 0.33900000562425703,
          "_blocked_queueing": 2.4600000033387914
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetLobby",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331223,
                "columnNumber": 26
              },
              {
                "functionName": "getLobbyData",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 354112,
                "columnNumber": 62
              },
              {
                "functionName": "executeAction$$1",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80971,
                "columnNumber": 18
              },
              {
                "functionName": "res",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 80963,
                "columnNumber": 15
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333233,
                "columnNumber": 68
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      },
      {
        "startedDateTime": "2020-04-15T21:11:11.395Z",
        "time": 24.202999993576668,
        "request": {
          "method": "POST",
          "url": "https://v2.shake-it-up.net/interaction?route=get-notifications",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": ":method",
              "value": "POST"
            },
            {
              "name": ":authority",
              "value": "v2.shake-it-up.net"
            },
            {
              "name": ":scheme",
              "value": "https"
            },
            {
              "name": ":path",
              "value": "/interaction?route=get-notifications"
            },
            {
              "name": "content-length",
              "value": "93"
            },
            {
              "name": "user-agent",
              "value": "Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/81.0.4044.92 Safari/537.36"
            },
            {
              "name": "content-type",
              "value": "text/plain;charset=UTF-8"
            },
            {
              "name": "accept",
              "value": "*/*"
            },
            {
              "name": "origin",
              "value": "http://localhost:3000"
            },
            {
              "name": "sec-fetch-site",
              "value": "cross-site"
            },
            {
              "name": "sec-fetch-mode",
              "value": "cors"
            },
            {
              "name": "sec-fetch-dest",
              "value": "empty"
            },
            {
              "name": "referer",
              "value": "http://localhost:3000/"
            },
            {
              "name": "accept-encoding",
              "value": "gzip, deflate, br"
            },
            {
              "name": "accept-language",
              "value": "en-US,en;q=0.9"
            }
          ],
          "queryString": [
            {
              "name": "route",
              "value": "get-notifications"
            }
          ],
          "cookies": [],
          "headersSize": -1,
          "bodySize": 93,
          "postData": {
            "mimeType": "text/plain;charset=UTF-8",
            "text": "{\"Route\":\"get-notifications\",\"Payload\":{},\"Token\":\"e0b5cf42a1db23dd32bd63d7dc30a03ea3cad139\"}"
          }
        },
        "response": {
          "status": 200,
          "statusText": "",
          "httpVersion": "http/2.0",
          "headers": [
            {
              "name": "status",
              "value": "200"
            },
            {
              "name": "access-control-allow-origin",
              "value": "*"
            },
            {
              "name": "content-type",
              "value": "application/json"
            },
            {
              "name": "content-length",
              "value": "68"
            },
            {
              "name": "date",
              "value": "Wed, 15 Apr 2020 21:11:10 GMT"
            }
          ],
          "cookies": [],
          "content": {
            "size": 68,
            "mimeType": "application/json",
            "text": "{\"Payload\":{\"UserNotifications\":[]},\"ErrorCode\":0,\"ErrorMessage\":\"\"}"
          },
          "redirectURL": "",
          "headersSize": -1,
          "bodySize": -1,
          "_transferSize": 114
        },
        "cache": {},
        "timings": {
          "blocked": 2.7860000023487954,
          "dns": -1,
          "ssl": -1,
          "connect": -1,
          "send": 0.133,
          "wait": 20.97200000202004,
          "receive": 0.311999989207834,
          "_blocked_queueing": 2.6720000023487955
        },
        "serverIPAddress": "52.53.251.41",
        "_initiator": {
          "type": "script",
          "stack": {
            "callFrames": [
              {
                "functionName": "",
                "scriptId": "22047",
                "url": "",
                "lineNumber": 0,
                "columnNumber": 875
              },
              {
                "functionName": "SendPacket",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348683,
                "columnNumber": 10
              },
              {
                "functionName": "CallRoute",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348607,
                "columnNumber": 15
              },
              {
                "functionName": "GetNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 331179,
                "columnNumber": 26
              },
              {
                "functionName": "clearNotifications",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 348513,
                "columnNumber": 55
              },
              {
                "functionName": "Lobby._this.poll",
                "scriptId": "22068",
                "url": "http://localhost:3000/static/js/bundle.js",
                "lineNumber": 333234,
                "columnNumber": 70
              }
            ],
            "parent": {
              "description": "setInterval",
              "callFrames": [
                {
                  "functionName": "Lobby",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 333238,
                  "columnNumber": 23
                },
                {
                  "functionName": "constructClassInstance",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 305847,
                  "columnNumber": 17
                },
                {
                  "functionName": "updateClassComponent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 307618,
                  "columnNumber": 4
                },
                {
                  "functionName": "beginWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 308445,
                  "columnNumber": 15
                },
                {
                  "functionName": "performUnitOfWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311183,
                  "columnNumber": 11
                },
                {
                  "functionName": "workLoop",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311223,
                  "columnNumber": 23
                },
                {
                  "functionName": "renderRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 311309,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWorkOnRoot",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312200,
                  "columnNumber": 6
                },
                {
                  "functionName": "performWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312112,
                  "columnNumber": 6
                },
                {
                  "functionName": "performSyncWork",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312086,
                  "columnNumber": 2
                },
                {
                  "functionName": "interactiveUpdates$1",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 312355,
                  "columnNumber": 6
                },
                {
                  "functionName": "interactiveUpdates",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 295532,
                  "columnNumber": 9
                },
                {
                  "functionName": "dispatchInteractiveEvent",
                  "scriptId": "22068",
                  "url": "http://localhost:3000/static/js/bundle.js",
                  "lineNumber": 298239,
                  "columnNumber": 2
                }
              ]
            }
          }
        },
        "_priority": "High",
        "_resourceType": "fetch",
        "connection": "373383",
        "pageref": "page_17"
      }
    ]
  }
}